// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"47bb5e06","911":"8558aafd"}[chunkId] + ".chunk.css";
};